import React, { useEffect } from 'react';

interface ModalProps {
    title?: string;
    content?: string;
    onClose: () => void;
    children?: React.ReactNode;
    isOpen: boolean;
}

const Modal: React.FC<ModalProps> = ({ title, content, onClose, children, isOpen }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
        <div className="mobile:px-6">
          <div className="bg-white p-6 rounded-lg shadow-lg transition-all duration-500 ease-in-out">
            {title && (
              <h2 className="text-2xl font-bold text-gray-800 mobile:text-lg mb-4 border-b pb-3">
                {title}
              </h2>
            )}
            <div className="overflow-y-auto max-h-96">
              {content && (
                <p className="text-gray-700 mb-2 mobile:text-xs mobile:leading-5 leading-relaxed whitespace-pre-line">
                  {content}
                </p>
              )}
              {children}
            </div>
            <div className="flex justify-end mt-4">
              <button
                onClick={onClose}
                className="bg-MainColor hover:bg-opacity-80 tracking-wide mobile:text-xs text-white font-bold py-2 px-8 mobile:px-4 rounded"
              >
                확인
              </button>
            </div>
          </div>
        </div>
      </div>
    );
};

export default Modal;
